import { App, URLOpenListenerEvent } from "@capacitor/app";
import { useFSRSModal } from "hooks/util/useFSRSModal";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

// NOTE: this file handles deeplinks by triggering the router with the correct path.
// The difference between this file and src/ts/screens/deeplink.tsx is that that one
// handles being routed to the deeplink path, so the web app can use it too.

const deeplinkTLD = "ankiapp.com";
const customScheme = "ankiapp://";

export default function DeeplinkHandler(): null {
  const history = useHistory();
  const { presentFSRSModal } = useFSRSModal();

  useEffect(() => {
    const handleAppUrlOpen = (event: URLOpenListenerEvent) => {
      try {
        const { url } = event;
        console.log("[DeeplinkHandler] Processing URL:", url);

        // Handle ankiapp:// custom scheme
        if (url.startsWith(customScheme)) {
          const path = url.replace(customScheme, "");
          console.log("[DeeplinkHandler] Processing custom scheme path:", path);

          // Handle specific deep link actions
          if (path === "fsrs") {
            console.log("[DeeplinkHandler] Opening FSRS modal");
            // Open FSRS modal
            setTimeout(() => {
              try {
                presentFSRSModal();
              } catch (error) {
                console.error("[DeeplinkHandler] Failed to present FSRS modal:", error);
              }
            }, 500); // Small delay to ensure app is ready
          } else if (path.startsWith("/")) {
            console.log("[DeeplinkHandler] Navigating to path:", path);
            // Navigate to path
            history.push(path);
          } else if (path) {
            const fullPath = `/${path}`;
            console.log("[DeeplinkHandler] Navigating to path with leading slash:", fullPath);
            // Navigate to path with leading slash
            history.push(fullPath);
          } else {
            console.log("[DeeplinkHandler] Empty path, navigating to home");
            history.push("/home");
          }
        }
        // Handle existing ankiapp.com URLs
        else if (url.includes(deeplinkTLD)) {
          const pathAndQueryArgs = url.split(deeplinkTLD)[1];
          if (pathAndQueryArgs) {
            console.log("[DeeplinkHandler] Navigating to legacy URL path:", pathAndQueryArgs);
            history.push(pathAndQueryArgs);
          }
        } else {
          console.warn("[DeeplinkHandler] Unrecognized URL format:", url);
        }
      } catch (error) {
        console.error("[DeeplinkHandler] Error processing deep link:", error);
      }
    };

    App.addListener("appUrlOpen", handleAppUrlOpen);

    return () => {
      App.removeAllListeners();
    };
  }, [history, presentFSRSModal]);

  return null;
}
